
export default function DynamicBanner({serviceData}){
    return(
        <>
       

    <section className="detailserv-head header-gap">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <span className="sub-tittle">Luxury Interior</span>
                    <h1 className="heading">{serviceData?.title}</h1>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: serviceData?.first_description,
                        }}
                        />
                    </div>
        
                </div>
        </div>

        <img src={serviceData?.banner_image} loading="lazy" className="img-responsive" alt={serviceData?.tag}/>
    </section>  
        </>
    )
}